import { useStyles, Button, Flex } from '@archipro-design/aria';
import * as S from './HeaderSection.style';
import { useMatchesHandleData } from '@modules/root';
import { useTracker } from '@archipro-website/tracker';
import type { EnquiryItemType } from '~/modules/tracking/util/trackEnquireReveal';
import { trackBookConsultationReveal } from '~/modules/tracking/util/trackEnquireReveal';
import BookingModal from '@modules/enquiry/component/booking-modal/BookingModal';
import { InboxCustom } from '@archipro-design/icons';
import type { BookConsultationProfessional } from '@modules/enquiry/component/enquiry-form/EnquiryForm';

interface BookProfessionalProps {
    professional: BookConsultationProfessional;
    enquiryType: EnquiryItemType;
    trackingRecordID?: number;
    openEnquiryModal: () => void;
}

const BookProfessional = ({
    professional,
    enquiryType,
    trackingRecordID,
    openEnquiryModal,
}: BookProfessionalProps) => {
    const { ID, Title, TeamCalendarURLSegment, Link } = professional;
    const isBMPreview = useMatchesHandleData('isBMPreview', false);
    const tracker = useTracker();
    const { css } = useStyles({ isBMPreview });

    return (
        <Flex className={css(S.EnquiryAndSaveWrapper)}>
            {TeamCalendarURLSegment && (
                <BookingModal
                    teamBookingSegment={TeamCalendarURLSegment}
                    professionalUrl={Link}
                    trigger={
                        <Button
                            color="dark"
                            disabled={isBMPreview}
                            className={css(S.HeaderButton)}
                            size={16}
                            onClick={() =>
                                trackBookConsultationReveal(tracker, {
                                    professionalName: Title,
                                    itemID: trackingRecordID || ID,
                                    itemType: enquiryType,
                                    professionalID: ID,
                                })
                            }
                        >
                            Book a consultation
                        </Button>
                    }
                />
            )}
            <Button
                variant="outlined"
                disabled={isBMPreview}
                className={css(S.SquareIconButton)}
                size={16}
                icon={<InboxCustom />}
                onClick={openEnquiryModal}
            />
        </Flex>
    );
};

export default BookProfessional;
